import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";

const getOwnerRegistrationData = (id = null) => {
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [, applicationFlow] = useDepartmentSelector();
  const [usersData, setUsersData] = useState({});

  if (id) {
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPAOwnerRegistration(tenantId, { applicationNo: id });
    };

    const { data, isLoading: isAppDataLoading, isSuccess } = useQuery({ queryKey: [id], queryFn: fetchApplicationData });
    const applicationData = isSuccess && data?.ownerRegistration?.[0];
    return { applicationData, isAppDataLoading };
  }

  const { info: userInfo } = Digit.UserService.getUser();
  const userUid = userInfo?.uuid;
  const applicationType = "FORM_OWNER_REGISTRATION";
  const { documents } = useSelector((state) => state.formMT);

  async function searchUser() {
    try {
      const response = await Digit.UserService.userSearch(tenantId, { uuid: [userUid] }, {});
      setUsersData(response);
      return response;
    } catch (error) {
      console.error("Error during user search:", error);
    }
  }
  useEffect(() => {
    searchUser();
  }, []);
  const registrationArchitectNumber = usersData?.user?.[0]?.registrationArchitectNumber;

  const applicationData = {
    tenantId,
    professionalInformation: {
      name: userInfo?.name,
      mobileNumber: userInfo?.mobileNumber,
      emailId: userInfo?.emailId,
      address: {
        address: userInfo?.permanentAddress,
        district: null,
        state: null,
      },
      registrationNumber: userInfo?.registrationNumber,
      registrationArchitectNumber: registrationArchitectNumber,
    },
    descriptionOfLand: {
    },
    checklist: {
      allotmentDate: null,
      isPossesionAreaDiff: null,
      areaOfExtraLand: null,
      paymentStatus: null,
      agreementDate: null,
      uptodatePaymentStatus: null,
      registryStatus: null
    },
    applicationType,
    approvedLayout: null,
    feeType: "ApplicationFee",
    department: applicationFlow,
    workflow: { action: "INITIATE", assignes: [userUid] },
    landInfo: {
      tenantId,
      owners: null,
      address:{
        tenantId,
        locality: {
          code: "Lucknow"
        }
      },
      bankdetails: {
        accountHolderName: null,
        branchName: null,
        ifscCode: null, 
        accountNo: null,
        bankName: null,
      }
    },
    businessService: "BPA_OWNER_REGISTRATION",
    documents,
    uiFlow: { flow: "FORM_OWNER_REGISTRATION" },
  };

  return { applicationData, isAppDataLoading: false };
};

export default getOwnerRegistrationData;
